<div class="overlay" data-cy="delete-confirmation-parent">
    <div class="content center-content">
        <div class="column-flex">
            <div class="top-container">
                <div class="header">
                    <div data-cy="delete-confirmation-subheader">
                        {{ data.title | translate }}
                    </div>
                    <div class="name" data-cy="delete-confirmation-header">
                        {{ data.name }}
                    </div>
                </div>
                <div class="message-text" data-cy="delete-confirmation-text">
                    {{ data.message1 | translate }}
                </div>

                <div class="message-text" *ngIf="data.message2">
                    <div data-cy="delete-confirmation-subtext">
                        {{ data.message2 | translate }}
                    </div>
                    <div class="input-container">
                        <app-channel-text-input
                            [value]="inputName"
                            [label]="data.inputLegend"
                            [placeholder]="data.inputPlaceholder"
                            (onInputChange)="nameChange($event.value)"
                            (onFocusChange)="nameChange($event.value)"></app-channel-text-input>
                    </div>
                </div>
            </div>

            <div class="buttons-wrapper">
                <div class="buttons-container">
                    <div class="button" data-cy="delete-confirmation-cancel-button" (click)="cancel()">
                        {{ data.cancelButton | translate }}
                    </div>
                    <div
                        class="create button"
                        data-cy="delete-confirmation-window-confirm-button"
                        (click)="deleteElement()"
                        [class.disabledButton]="!deleteIsEnabled">
                        {{ data.buttonDelete | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
